import { authConstants } from '../../constants'

const user = JSON.parse(localStorage.getItem('user'))

const initialState = {
  isLoggedIn: !!user,
  isLoading: false,
  isFailure: false,
  data: null,
  isCalled: false,
  pinReSet: false,
  uuid: null,
  deviceId: null,
  pwdConfirm: false,
  showPwdPopup: false,
}

user && (initialState.user = user)

export default function auth(state = initialState, action) {
  switch (action.type) {
    /********************
      로그인
    ********************/

    case authConstants.LOGIN_REQUEST:
      return {
        ...state,
      }
    case authConstants.LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
      }
    case authConstants.LOGIN_FAILURE:
      return {}

    /********************
      간편 로그인
    ********************/
    case authConstants.PASS_LOGIN_REQUEST:
      return {
        ...state,
        pinReSet: false,
      }
    case authConstants.PASS_LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        pinReSet: false,
      }
    case authConstants.PASS_LOGIN_FAILURE:
      return {
        ...state,
        pinReSet: true,
      }

    /********************
       아이디 찾기, 비밀번호 찾기
     ********************/
    case authConstants.FIND_REQUEST:
      return {
        ...state,
      }
    case authConstants.FIND_SUCCESS:
      return {
        ...state,
        data: action.response.data?.payload,
        isCalled: true,
      }
    case authConstants.FIND_FAILURE:
      return {}
    case authConstants.RESET_FIND_INFO:
      return {
        ...state,
        data: null,
        isCalled: false,
      }
    /********************
      사용자 조회
    ********************/

    case authConstants.USER_INFO_REQUEST:
      return {
        ...state,
      }
    case authConstants.USER_INFO_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
      }
    case authConstants.USER_INFO_FAILURE:
      return {}

    /********************
      로그아웃
    ********************/

    case authConstants.LOGOUT:
      return {
        isLoggedIn: false,
      }

    default:
      return state

    /********************
       디지털원패스
     ********************/
    case authConstants.DIGTOP_REQUEST:
      return {
        ...state,
      }
    case authConstants.DIGTOP_SUCCESS:
      return {
        ...state,
        data: action.response.data?.payload,
        //isLoggedIn: true,
        isCalled: true,
      }
    case authConstants.DIGTOP_FAILURE:
      return {}

    /********************
       qr 이미지 생성
     ********************/
    case authConstants.QRIMG_REQUEST:
      return {
        ...state,
      }
    case authConstants.QRIMG_SUCCESS:
      return {
        ...state,
        data: action.response.data?.payload,
        isCalled: true,
      }
    case authConstants.QRIMG_FAILURE:
      return {}

    /********************
       UUID CHECK
     ********************/
    case authConstants.MOBILE_UUID_REQUEST:
      return {
        ...state,
      }
    case authConstants.MOBILE_UUID_SUCCESS:
      return {
        ...state,
        uuid: action.response.data?.payload,
        isCalled: true,
      }
    case authConstants.MOBILE_UUID_FAILURE:
      return {}

    /********************
      deviceId 가져오기
    ********************/
    case authConstants.GET_DEVICE_ID_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case authConstants.GET_DEVICE_ID_SUCCESS:
      return {
        ...state,
        deviceId: action.response.data?.payload,
      }
    case authConstants.GET_DEVICE_ID_FAILURE:
      return {
        isLoading: false,
        isFailure: true,
      }

    case authConstants.SHOW_PWD_POPUP:
        return{
            ...state,
            showPwdPopup: action.isShow,
            requestType: action.requestType,
            pwdConfirm: action.pwdConfirm,
            value: action.value,
        }

    case authConstants.PWD_REQUEST:
        return {
            ...state,
            pwdConfirm:null,
        }
    case authConstants.PWD_SUCCESS:
        // 서버사이드 step-up 도입 후 응답 본문에는 payload가 없다(서버 메모리만이 권위).
        // 옛 코드는 action.response.data.payload.isMatched를 읽었으나, payload가 undefined가 되어
        // TypeError가 발생하고 thunk .then 안의 throw가 Promise reject로 전파되는 문제가 있었다.
        // 200 응답이 도달했다는 사실 자체가 통과 신호이므로 단순 boolean으로 처리한다.
        return {
            ...state,
            pwdConfirm: true,
        }
    case authConstants.PWD_FAILURE:
        return {
            ...state,
            pwdConfirm: null,
        }
  }
}
